import React from 'react';
export function BrandHeader() {
  return <header className="w-full py-6 flex justify-center items-center bg-base z-50 relative" data-id="element-43">
      <div className="text-primary font-bold tracking-widest uppercase text-sm md:text-base flex items-center gap-2" data-id="element-44">
        <span data-id="element-45">💪</span> BIBLIOTECAS DIGITALES™
      </div>
    </header>;
}